import React, { useContext } from "react";
import CustomCard from "../../styleComp/CustomCard";
import { Typography, Button } from "@mui/material";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import BadgeIcon from "@mui/icons-material/Badge";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import { useNavigate } from "react-router-dom";
import { RolesContext } from "../../context/User";

const ProfileCard = ({ colorCard, mobil }) => {
  const navigate = useNavigate();
  const [stateroles, dispatchroles] = useContext(RolesContext);

  const profilNavigation = () => {
    navigate(`/roles`);
  };

  return (
    <>
      {/* // --------------------------display XL---------------------- */}
      <Box
        sx={{ display: { xs: "none", md: "none", xl: "flex" } }}
        justifyContent="center"
        alignItems="center"
      >
        <CustomCard
          widthCard={"100vw"}
          heightCard={"31.5vh"}
          backgroundColorStyle={colorCard ? colorCard : null}
        >
          <Box display="flex" flexDirection="column" alignItems="center">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: mobil ? "0.5rem" : "2rem",
                justifyContent: "center",
              }}
            >
              <BadgeIcon />
              <Typography
                variant="h5"
                style={{
                  marginRight: "5px",
                  alignItems: "center",
                  textAlign: "center",
                  fontFamily: "'Varela Round', sans-serif",
                }}
              >
                פרטים אישיים
              </Typography>
            </div>
            <Typography
              variant="h6"
              sx={{
                marginTop: mobil ? "0.5rem" : "1.5rem",
                alignItems: "center",
                textAlign: "center",
                fontFamily: "'Varela Round', sans-serif",
              }}
            >
              {stateroles.name}
            </Typography>
            <Typography
              sx={{
                textAlign: "center",
                fontFamily: "'Varela Round', sans-serif",
              }}
            >
              {stateroles.phone?.includes('@') ? 'מייל' : 'טלפון'}: {stateroles.phone}
            </Typography>
            {stateroles.roles.includes("admin") ||
            stateroles.roles.includes("roles") ? (
              <Button
                variant="contained"
                color="primary"
                startIcon={<AccountBoxIcon />}
                onClick={profilNavigation}
                sx={{
                  marginTop: mobil ? "1rem" : "2rem",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  display: "flex",
                  fontFamily: "'Varela Round', sans-serif",
                }}
              >
                פרופיל שלי
              </Button>
            ) : null}
          </Box>
        </CustomCard>
      </Box>
      {/* // --------------------------display MD---------------------- */}
      <Box
        sx={{ display: { xs: "none", md: "flex", xl: "none" } }}
        justifyContent="center"
        alignItems="center"
      >
        <CustomCard
          widthCard={"100vw"}
          heightCard={"31.5vh"}
          backgroundColorStyle={colorCard ? colorCard : null}
        >
          <Box display="flex" flexDirection="column" alignItems="center">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: mobil ? "0.5rem" : "0.5rem",
                justifyContent: "center",
              }}
            >
              <BadgeIcon />
              <Typography
                variant="h6"
                style={{
                  marginRight: "5px",
                  alignItems: "center",
                  textAlign: "center",
                  fontFamily: "'Varela Round', sans-serif",
                }}
              >
                פרטים אישיים
              </Typography>
            </div>
            <Typography
              variant="subtitle1"
              sx={{
                marginTop: "0.5rem",
                alignItems: "center",
                textAlign: "center",
                fontFamily: "'Varela Round', sans-serif",
              }}
            >
              {stateroles.name}
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                textAlign: "center",
                fontFamily: "'Varela Round', sans-serif",
              }}
            >
              {stateroles.phone?.includes('@') ? 'מייל' : 'טלפון'}: {stateroles.phone}
            </Typography>
            {stateroles.roles.includes("admin") ||
            stateroles.roles.includes("roles") ? (
              <Button
                variant="contained"
                color="primary"
                startIcon={<AccountBoxIcon />}
                onClick={profilNavigation}
                sx={{
                  marginTop: "1rem",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  display: "flex",
                  fontFamily: "'Varela Round', sans-serif",
                }}
              >
                פרופיל שלי
              </Button>
            ) : null}
          </Box>
        </CustomCard>
      </Box>

      {/* // --------------------------display XS---------------------- */}
      <Box
        sx={{ display: { xs: "flex", md: "none", xl: "none" } }}
        justifyContent="center"
        alignItems="center"
      >
        <CustomCard
          widthCard={"100vw"}
          heightCard={"30vh"}
          backgroundColorStyle={colorCard ? colorCard : null}
        >
          <Box display="flex" flexDirection="column" alignItems="center">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: mobil ? "0.5rem" : "0.5rem",
                justifyContent: "center",
              }}
            >
              <BadgeIcon />
              <Typography
                variant="h6"
                style={{
                  marginRight: "5px",
                  alignItems: "center",
                  textAlign: "center",
                  fontFamily: "'Varela Round', sans-serif",
                }}
              >
                פרטים אישיים
              </Typography>
            </div>
            <Typography
              variant="subtitle1"
              sx={{
                marginTop: "0.5rem",
                alignItems: "center",
                textAlign: "center",
                fontFamily: "'Varela Round', sans-serif",
              }}
            >
              {stateroles.name}
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                textAlign: "center",
                fontFamily: "'Varela Round', sans-serif",
              }}
            >
              {stateroles.phone?.includes('@') ? 'מייל' : 'טלפון'}: {stateroles.phone}
            </Typography>
            {stateroles.roles.includes("admin") ||
            stateroles.roles.includes("roles") ? (
              <Button
                variant="contained"
                color="primary"
                startIcon={<AccountBoxIcon />}
                onClick={profilNavigation}
                sx={{
                  marginTop: "1rem",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  display: "flex",
                  fontFamily: "'Varela Round', sans-serif",
                }}
              >
                פרופיל שלי
              </Button>
            ) : null}
          </Box>
        </CustomCard>
      </Box>
    </>
  );
};

export default ProfileCard;
